import {PIXI} from '@colonist/pixi'
import {SpriteView} from '../../../ui_canvas_engine/SpriteView'
import {UIGameManager} from '../../UIGameManager'
import {UIGameDiceView} from '../../ui_game_dice/UIGameDiceView'
import {Sprites} from '../../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../../UIGameSpriteHandler'
import {TranslationObject} from '@colonist/i18n'
import {MechanicEventDiceState} from '@colonist/game-states'

export class UIGameEventDiceView extends UIGameDiceView {
    readonly diceIcon: SpriteView
    readonly eventDice: SpriteView

    private readonly eventDiceState: MechanicEventDiceState

    constructor(uiGameManager: UIGameManager, eventDiceState: MechanicEventDiceState, x: number, y: number, diceSize: number, container: PIXI.Container, clickAction: (dice: PIXI.Container) => void, isMyDice: boolean = true) {
        super(uiGameManager, x, y, diceSize, diceSize, container, clickAction, isMyDice)
        this.eventDiceState = eventDiceState
        this.eventDice = new SpriteView(0, 0, diceSize, diceSize, this, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.dice))
        this.addDice(this.eventDice)

        const diceImageSize = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.dice).width
        this.diceIcon = new SpriteView(diceImageSize * 0.2, diceImageSize * 0.2, diceImageSize * 0.6,
            diceImageSize * 0.6, this.eventDice, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_barbarian_ship))

        const eventDiceTipTitle: TranslationObject = {key: 'strings:game.tips.eventDice.title'}
        const eventDiceTipBody: TranslationObject[] = [{key: 'strings:game.tips.eventDice.body.0'}, {key: 'strings:game.tips.eventDice.body.1'}]
        this.setTip(eventDiceTipTitle, eventDiceTipBody)
        this.bindClickAction()

        this.updateDiceTexture()
    }

    bindClickAction() {
        if(this.clickAction == undefined) return
        this.eventDice.setClickAction(() => this.clickAction(this.eventDice))
    }

    updateDiceTexture() {
        this.eventDice.texture = UIGameSpriteHandler.getEventDiceBackground(this.eventDiceState.eventDice)
        this.diceIcon.texture = UIGameSpriteHandler.getEventDiceIcon(this.eventDiceState.eventDice)
    }
}
